/**
 * Reference to the buyer of the cap rate option through its trade side.
 * tag: 40798
 * @readonly
 * @enum {number} (int)
 */
export enum PaymentStreamCapRateBuySide {
  /** Buyer of the trade */
  Buyer = 1,
  /** Seller of the trade */
  Seller = 2,
}
